import React, {useCallback} from 'react'
import '../../assets/css/pop.scss';

import { Checkbox,Radio } from 'pretty-checkbox-react';
import InputMask from 'react-input-mask';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faTimesCircle, faTimes, faClock} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Functions from "../../helpers/functions";
import Select from "react-select";
import 'react-tabs/style/react-tabs.css';
import Stepper from "react-stepper-horizontal";
import IntlTelInput from "react-intl-tel-input";


const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}


export default class createCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.defaultVars = {
            step:0,
            done:false,
            companyId:0,
            companyName:"",
            companyAddress:"",
            contactFullName:"",
            contactEmail:"",
            contactPhone:"",
            countries:[],
            country:{ value: 0, label: 'Select Country' },
        };

        this.title = ["Customer Info","Contact Info"];

        if(typeof props.data.id != "undefined"){
            this.defaultVars.companyId = props.data.id;
            this.defaultVars.companyName = props.data.name;
            this.defaultVars.companyAddress = props.data.address;
            this.defaultVars.contactFullName = props.data.contactFullName;
            this.defaultVars.contactEmail = props.data.email;
            this.defaultVars.contactPhone = props.data.phone;
            if(props.data.country != null){
                this.defaultVars.country = { value: parseInt(props.data.country.id), label: props.data.country.countryName };
            }
        }

        this.state = this.defaultVars;
    }
    componentDidMount(){
        this.getCountries();
    }
    async getCountries(){
        try {
            var url = Functions.generateURI("/customers/getCountries",{});

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){

                var countries = [];
                countries.push({ value: 0, label: "Select Country" });


                response.data.forEach((data)=>{
                    countries.push({ value: data.id, label: data.countryName });


                });
                this.setState({countries:countries});
            } else {

            }
        } catch(error) {

        }
    }
    async createCustomerNow(){
        this.setState({loading:true});
        try {

            var url = Functions.generateURI(
                "/customers/create",
                {
                    companyId:this.state.companyId,
                    companyName:this.state.companyName,
                    country:this.state.country.value,
                    companyAddress:this.state.companyAddress,
                    contactFullName:this.state.contactFullName,
                    contactEmail:this.state.contactEmail,
                    contactPhone:this.state.contactPhone,
                    method:"POST"
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.props.closePopUp();
                Actions.emit("closeSidePanel");
            } else {

            }
        } catch(error) {

        }
    }
    render(){

        return (
            <div id={"popForm"}>
                <span className={"close"} onClick={()=>{
                    // eslint-disable-next-line no-restricted-globals
                    var r = confirm("Are you sure to close ?");
                    if (r == true) {
                        this.props.closePopUp();
                        Actions.emit("closeSidePanel");
                    }
                }}><FontAwesomeIcon  icon={faTimes} size="lg"/></span>
                <div className={"row"}>
                    <div className={"columns small-12"}>
                        <div className={"title"}>{this.title[this.state.step]}</div>
                        <div className={"stepper"}>
                            <Stepper titleTop={4} circleTop={0} size={26} circleFontSize={18} defaultBorderStyle={{lineHeight:0}} steps={ [{title:"Company"},{title:"Customer"}] } titleFontSize={12} defaultTitleColor={"#666"} activeTitleColor={"#4085c7"} completeTitleColor={"#4085c7"} activeBorderColor={"#666"} defaultBarColor={"#CCC"} activeStep={ this.state.step} />
                        </div>
                        <div className={"container"}>
                            {this.renderStep(this.state.step)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderStep(step){
        switch(step){
            case 0:
                return(
                    <div className="inputWrapper">
                        <div className={"inputLabel"}>Company Name</div>
                        <input className={"input"} type={"text"} value={this.state.companyName} style={{textAlign:'center'}}
                               onChange={(e) => {
                                   this.setState({companyName:e.target.value});
                               }}/>
                        <div className={"inputLabel"}>Company Country</div>
                        <Select
                            styles={selectStyle}
                            value={this.state.country}
                            onChange={(val)=>{
                                this.setState({country:val});
                            }}
                            options={this.state.countries}
                        />
                        <div className={"inputLabel"}>Company Address</div>
                        <input className={"input"} type={"text"} value={this.state.companyAddress} style={{textAlign:'center'}}
                               onChange={(e) => {
                                   this.setState({companyAddress:e.target.value});
                               }}/>
                        <div className="buttons">
                            <a className={"button"} onClick={()=>{
                                this.setState({step:1});
                            }}>Continue</a>
                        </div>
                    </div>
                );
                break;
            case 1:
                return(
                    <div className="inputWrapper">
                        <div className={"inputLabel"}>Contact Fullname</div>
                        <input className={"input"} type={"text"} value={this.state.contactFullName} style={{textAlign:'center'}}
                               onChange={(e) => {
                                   this.setState({contactFullName:e.target.value});
                               }}/>
                        <div className={"inputLabel"}>Contact E-mail</div>
                        <input className={"input"} type={"text"} value={this.state.contactEmail} style={{textAlign:'center'}}
                               onChange={(e) => {
                                   this.setState({contactEmail:e.target.value});
                               }}/>
                        <div className={"inputLabel"}>Contact Phone</div>
                        <input className={"input"} type={"text"} value={this.state.contactPhone} style={{textAlign:'center'}}
                               onChange={(e) => {
                                   this.setState({contactPhone:e.target.value});
                               }}/>
                        <div className="buttons">
                            <a className={"button"} onClick={()=>{
                                this.createCustomerNow();
                            }}>{(this.state.companyId > 0?"UPDATE":"CREATE")}</a>
                        </div>
                    </div>
                );
                break;
        }
    }
}

